/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClaimPhoto } from './ClaimPhoto';
import {
    ClaimPhotoFromJSON,
    ClaimPhotoFromJSONTyped,
    ClaimPhotoToJSON,
    ClaimPhotoToJSONTyped,
} from './ClaimPhoto';

/**
 * List of photos for a claim.
 * @export
 * @interface ListClaimPhotosResponse
 */
export interface ListClaimPhotosResponse {
    /**
     * 
     * @type {Array<ClaimPhoto>}
     * @memberof ListClaimPhotosResponse
     */
    items: Array<ClaimPhoto>;
    /**
     * 
     * @type {number}
     * @memberof ListClaimPhotosResponse
     */
    total: number;
}

/**
 * Check if a given object implements the ListClaimPhotosResponse interface.
 */
export function instanceOfListClaimPhotosResponse(value: object): value is ListClaimPhotosResponse {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function ListClaimPhotosResponseFromJSON(json: any): ListClaimPhotosResponse {
    return ListClaimPhotosResponseFromJSONTyped(json, false);
}

export function ListClaimPhotosResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListClaimPhotosResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(ClaimPhotoFromJSON)),
        'total': json['total'],
    };
}

export function ListClaimPhotosResponseToJSON(json: any): ListClaimPhotosResponse {
    return ListClaimPhotosResponseToJSONTyped(json, false);
}

export function ListClaimPhotosResponseToJSONTyped(value?: ListClaimPhotosResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(ClaimPhotoToJSON)),
        'total': value['total'],
    };
}

